import drcStore from './store-drc.js';
import dataDeviceInfo from './data-device-info.js';
import dataNetworkTest from './data-network-test.js';
import dataNetworkHealth from './data-network-health.js';

document.addEventListener('alpine:init', () => {

    Alpine.store('drc', drcStore);

    Alpine.data('deviceInfo', () => (dataDeviceInfo));

    Alpine.data('networkTest', () => (dataNetworkTest));

    Alpine.data('networkHealth', () => (dataNetworkHealth));
});